/**
 * RETOBLOCK "KHỐI CỦA TÔI" (MY BLOCKS) MODAL
 * Giao diện Popup tạo hàm / thủ tục tùy chỉnh chuẩn phong cách LEGO SPIKE Prime & Scratch 3.0.
 * Cho phép thêm tham số dạng viên thuốc (số/chữ), hình thoi (boolean), nhãn văn bản và xóa tham số.
 */

export class MyBlocksModal {
  constructor(options) {
    this.container = options.container;
    this.getWorkspace = options.getWorkspace;
    this.onCreated = options.onCreated;

    this.blockName = 'khối của tôi';
    this.parts = []; // Danh sách: { id, type: 'number_or_text' | 'boolean' | 'label', name: string }
    this.selectedPartId = null;

    this.init();
  }

  init() {
    this.container.innerHTML = `
      <div class="modal-overlay" id="my-blocks-modal-overlay">
        <div class="modal-card my-blocks-dialog-modal">
          <div class="modal-header my-blocks-header">
            <div class="modal-title">
              <span class="my-blocks-badge-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
                </svg>
              </span>
              <span>TẠO MỘT KHỐI (MAKE A BLOCK)</span>
            </div>
            <button class="btn-close-modal" id="btn-close-my-blocks" title="Đóng">&times;</button>
          </div>

          <div class="modal-body my-blocks-body">
            <!-- Vùng xem trước khối lệnh LEGO SPIKE trực quan -->
            <div class="my-blocks-preview-area">
              <div class="my-blocks-definition-pill" id="my-blocks-preview-block">
                <div class="my-blocks-hat-tab">định nghĩa</div>
                <div class="my-blocks-parts-container" id="my-blocks-parts-container">
                  <!-- Rendered dynamically -->
                </div>
              </div>
            </div>

            <!-- Nhãn thông báo lỗi nội bộ (thay thế alert) -->
            <div class="my-blocks-error-badge" id="my-blocks-error-badge" style="display: none;"></div>

            <!-- Thanh công cụ 3 nút chức năng chuẩn LEGO SPIKE -->
            <div class="my-blocks-toolbar">
              <button type="button" class="btn-tool-spike" id="btn-add-num-text" title="Thêm tham số giá trị số hoặc văn bản">
                <span class="tool-shape shape-pill"></span>
                <span>Thêm đầu vào (số hoặc chữ)</span>
              </button>

              <button type="button" class="btn-tool-spike" id="btn-add-boolean" title="Thêm tham số điều kiện đúng / sai">
                <span class="tool-shape shape-diamond"></span>
                <span>Thêm đầu vào (boolean)</span>
              </button>

              <button type="button" class="btn-tool-spike" id="btn-add-label" title="Thêm đoạn văn bản nhãn mô tả">
                <span class="tool-shape shape-label">ABC</span>
                <span>Thêm nhãn</span>
              </button>

              <button type="button" class="btn-tool-spike btn-tool-trash" id="btn-delete-part" title="Xóa tham số đang chọn" disabled>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M3 6h18m-2 0v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6m3 0V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
                </svg>
              </button>
            </div>
          </div>

          <div class="modal-footer my-blocks-footer">
            <button class="btn-secondary-modal" id="btn-cancel-my-blocks">Hủy</button>
            <button class="btn-primary-spike" id="btn-save-my-blocks">Lưu</button>
          </div>
        </div>
      </div>
    `;

    this.bindEvents();
  }

  bindEvents() {
    const overlay = document.getElementById('my-blocks-modal-overlay');
    const closeBtn = document.getElementById('btn-close-my-blocks');
    const cancelBtn = document.getElementById('btn-cancel-my-blocks');
    const saveBtn = document.getElementById('btn-save-my-blocks');

    const addNumTextBtn = document.getElementById('btn-add-num-text');
    const addBoolBtn = document.getElementById('btn-add-boolean');
    const addLabelBtn = document.getElementById('btn-add-label');
    const deletePartBtn = document.getElementById('btn-delete-part');

    closeBtn.addEventListener('click', () => this.hide());
    cancelBtn.addEventListener('click', () => this.hide());

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) this.hide();
    });

    addNumTextBtn.addEventListener('click', () => {
      const idx = this.parts.filter(p => p.type === 'number_or_text').length + 1;
      this.addPart({
        id: 'param_' + Date.now() + Math.random().toString(36).substr(2, 4),
        type: 'number_or_text',
        name: `số hoặc chữ ${idx}`
      });
    });

    addBoolBtn.addEventListener('click', () => {
      const idx = this.parts.filter(p => p.type === 'boolean').length + 1;
      this.addPart({
        id: 'param_' + Date.now() + Math.random().toString(36).substr(2, 4),
        type: 'boolean',
        name: `boolean ${idx}`
      });
    });

    addLabelBtn.addEventListener('click', () => {
      const idx = this.parts.filter(p => p.type === 'label').length + 1;
      this.addPart({
        id: 'label_' + Date.now() + Math.random().toString(36).substr(2, 4),
        type: 'label',
        name: `nhãn ${idx}`
      });
    });

    deletePartBtn.addEventListener('click', () => {
      if (this.selectedPartId) {
        this.removePart(this.selectedPartId);
      }
    });

    saveBtn.addEventListener('click', () => this.handleSave());
  }

  show() {
    this.blockName = 'khối của tôi';
    this.parts = [];
    this.selectedPartId = null;
    this.clearError();
    this.renderParts();

    const overlay = document.getElementById('my-blocks-modal-overlay');
    overlay.classList.add('active');

    setTimeout(() => {
      const nameInput = document.getElementById('my-blocks-main-name-input');
      if (nameInput) {
        nameInput.focus();
        nameInput.select();
      }
    }, 100);
  }

  showError(message) {
    const errorEl = document.getElementById('my-blocks-error-badge');
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.style.display = 'flex';
    }
    const nameInput = document.getElementById('my-blocks-main-name-input');
    if (nameInput) {
      nameInput.style.borderColor = '#EF4444';
      nameInput.focus();
    }
  }

  clearError() {
    const errorEl = document.getElementById('my-blocks-error-badge');
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }
    const nameInput = document.getElementById('my-blocks-main-name-input');
    if (nameInput) {
      nameInput.style.borderColor = '';
    }
  }

  hide() {
    const overlay = document.getElementById('my-blocks-modal-overlay');
    overlay.classList.remove('active');
  }

  selectPart(id) {
    this.selectedPartId = id;
    const container = document.getElementById('my-blocks-parts-container');
    if (container) {
      container.querySelectorAll('.my-blocks-part-item').forEach(item => {
        item.classList.toggle('selected', item.dataset.id === id);
      });
    }
    const deleteBtn = document.getElementById('btn-delete-part');
    if (deleteBtn) {
      deleteBtn.disabled = !this.selectedPartId;
    }
  }

  addPart(part) {
    this.parts.push(part);
    this.selectedPartId = part.id;
    this.renderParts();
    setTimeout(() => {
      const container = document.getElementById('my-blocks-parts-container');
      const inp = container ? container.querySelector(`.my-blocks-part-item[data-id="${part.id}"] input`) : null;
      if (inp) {
        inp.focus();
        inp.select();
      }
    }, 50);
  }

  removePart(id) {
    this.parts = this.parts.filter(p => p.id !== id);
    this.selectedPartId = null;
    this.renderParts();
  }

  renderParts() {
    const container = document.getElementById('my-blocks-parts-container');
    const deleteBtn = document.getElementById('btn-delete-part');

    if (deleteBtn) {
      deleteBtn.disabled = !this.selectedPartId;
    }

    let html = `
      <div class="my-blocks-item-wrap">
        <input type="text" class="my-blocks-name-input" id="my-blocks-main-name-input" value="${this.escapeHtml(this.blockName)}" placeholder="tên khối" />
      </div>
    `;

    this.parts.forEach(part => {
      const isSelected = part.id === this.selectedPartId ? 'selected' : '';
      const initialWidth = Math.max((part.name || '').length + 2, 8);
      if (part.type === 'number_or_text') {
        html += `
          <div class="my-blocks-part-item part-number-text ${isSelected}" data-id="${part.id}">
            <input type="text" class="part-inline-input" value="${this.escapeHtml(part.name)}" style="width: ${initialWidth}ch;" />
          </div>
        `;
      } else if (part.type === 'boolean') {
        html += `
          <div class="my-blocks-part-item part-boolean ${isSelected}" data-id="${part.id}">
            <input type="text" class="part-inline-input" value="${this.escapeHtml(part.name)}" style="width: ${initialWidth}ch;" />
          </div>
        `;
      } else if (part.type === 'label') {
        html += `
          <div class="my-blocks-part-item part-label ${isSelected}" data-id="${part.id}">
            <input type="text" class="part-inline-input" value="${this.escapeHtml(part.name)}" style="width: ${initialWidth}ch;" />
          </div>
        `;
      }
    });

    container.innerHTML = html;

    // Bind event cho main name input
    const nameInput = document.getElementById('my-blocks-main-name-input');
    if (nameInput) {
      nameInput.addEventListener('focus', () => {
        this.selectPart(null);
      });
      nameInput.addEventListener('input', (e) => {
        this.clearError();
        this.blockName = e.target.value;
      });
    }

    // Bind event cho từng tham số inline
    container.querySelectorAll('.my-blocks-part-item').forEach(el => {
      const id = el.dataset.id;
      const inp = el.querySelector('input');

      // Click vào khung chứa tham số thì chọn tham số đó mà KHÔNG render lại HTML
      el.addEventListener('click', (e) => {
        this.selectPart(id);
        if (inp && e.target !== inp) {
          inp.focus();
        }
      });

      if (inp) {
        inp.addEventListener('focus', () => {
          this.selectPart(id);
        });
        inp.addEventListener('click', (e) => {
          e.stopPropagation();
          this.selectPart(id);
        });
        inp.addEventListener('input', (e) => {
          const found = this.parts.find(p => p.id === id);
          if (found) {
            found.name = e.target.value;
          }
          inp.style.width = Math.max(e.target.value.length + 2, 8) + 'ch';
        });
      }
    });
  }

  handleSave() {
    this.clearError();
    const rawName = (this.blockName || '').trim();
    if (!rawName) {
      this.showError('Vui lòng nhập tên cho khối của bạn!');
      return;
    }

    const ws = typeof this.getWorkspace === 'function' ? this.getWorkspace() : null;
    if (!ws) {
      this.hide();
      return;
    }

    // Lọc danh sách tham số (number_or_text và boolean)
    const argParams = this.parts.filter(p => p.type === 'number_or_text' || p.type === 'boolean');
    const rawArgNames = argParams.map(p => (p.name || '').trim() || 'tham_so');

    // Thuật toán kiểm tra và xử lý chống trùng lặp tên tham số (Bug 06)
    const seenNames = new Map();
    const uniqueArgNames = [];

    for (let i = 0; i < rawArgNames.length; i++) {
      const originalName = rawArgNames[i];
      const lower = originalName.toLowerCase();
      if (!seenNames.has(lower)) {
        seenNames.set(lower, 1);
        uniqueArgNames.push(originalName);
      } else {
        const count = seenNames.get(lower) + 1;
        seenNames.set(lower, count);
        const resolvedName = `${originalName}_${count}`;
        uniqueArgNames.push(resolvedName);
        argParams[i].name = resolvedName;
      }
    }

    const argNames = uniqueArgNames;

    // Tạo khối định nghĩa trên Blockly Workspace
    try {
      const defBlock = ws.newBlock('procedures_defnoreturn');
      defBlock.setFieldValue(rawName, 'NAME');

      if (argNames.length > 0) {
        const varModels = argNames.map(name => ws.getVariableMap().createVariable(name));
        defBlock.argumentVarModels_ = varModels;
        defBlock.arguments_ = argNames;
        if (typeof defBlock.updateParams_ === 'function') {
          defBlock.updateParams_();
        }
      }

      // Vị trí đặt khối mới trên Canvas
      defBlock.initSvg();
      defBlock.render();

      const existingBlocks = ws.getTopBlocks(false);
      let posX = 80;
      let posY = 80;
      if (existingBlocks.length > 0) {
        const last = existingBlocks[existingBlocks.length - 1];
        if (last && last.getRelativeToSurfaceXY) {
          const xy = last.getRelativeToSurfaceXY();
          posX = xy.x + 30;
          posY = xy.y + 120;
        }
      }
      defBlock.moveTo(new Blockly.utils.Coordinate(posX, posY));

      // Refresh toolbox để hiển thị khối gọi caller trong danh mục KHỐI CỦA TÔI
      if (ws.refreshToolboxSelection) {
        ws.refreshToolboxSelection();
      }

      if (this.onCreated) {
        this.onCreated(rawName);
      }
    } catch (err) {
      console.error('Lỗi khi tạo procedure trong Blockly:', err);
    }

    this.hide();
  }

  escapeHtml(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
}
